import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectQuizProgressState = createSelector(selectState, (state) => state.quizProgress);

export const selectProgress = (quizId: string) => createSelector(selectQuizProgressState, (state) => state[quizId]?.progress ?? null);

export const selectProgressLoading = (quizId: string) => createSelector(selectQuizProgressState, (state) => state[quizId]?.loading ?? false);

export const selectProgressLoaded = (quizId: string) => createSelector(selectQuizProgressState, (state) => state[quizId]?.loaded ?? null);

export const selectSaving = (quizId: string) => createSelector(selectQuizProgressState, (state) => state[quizId]?.saving ?? false);

export const selectRetrying = (quizId: string) => createSelector(selectQuizProgressState, (state) => state[quizId]?.retrying ?? false);

export const selectIsFinished = (quizId: string) => createSelector(selectProgress(quizId), (progress) => progress?.finished ?? false);

export const selectIsPassed = (quizId: string) => createSelector(selectProgress(quizId), (progress) => progress?.passed ?? false);

export const selectAnswers = (quizId: string) => createSelector(selectProgress(quizId), (progress) => progress?.answers ?? []);

export const selectSelectedOption = (quizId: string, questionId: string) =>
    createSelector(selectProgress(quizId), (progress) => {
        if (!progress) return null;
        const answer = progress.answers.find((a) => a.questionId === questionId);
        return answer?.optionId ?? null;
    });
